import { useCallback, useEffect, useState } from "react";
import { BasicTable } from "../components/tables/BasicTable";
import { getAllGames } from "../services/gamesAPI";
import { Pagination } from "../components/pagination/Pagination";
import { formatDate } from "../utils/dateAndTime";
import { useNavigate } from "react-router-dom";
import { Search } from "../components/search/Search";
import { useLocation } from "react-router-dom";
import Loader from "../components/ui/loader";

export const Games = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const handleTeamClick = (teamID) => {
    navigate(`/team/${teamID}`);
  };

  const handleGameClick = (gameID) => {
    navigate(`/game/${gameID}`);
  };

  const handleLeagueClick = (leagueID) => {
    navigate(`/league/${leagueID}`);
  };

  const columns = [
    { key: "GameID", label: "ID", itemID: "GameID", clickHandler: handleGameClick },
    {
      key: "date",
      label: "Date",
      format: formatDate,
      itemID: "GameID",
      clickHandler: handleGameClick,
    },
    {
      key: "gameType",
      label: "Game Type",
      itemID: "GameID",
      clickHandler: handleGameClick,
    },
    { key: "round", label: "Round", itemID: "GameID", clickHandler: handleGameClick },
    {
      key: "description",
      label: "Game Description",
      itemID: "GameID",
      clickHandler: handleGameClick,
    },
    {
      key: "LeagueDetails.name",
      label: "League",
      itemID: "LeagueDetails.LeagueID",
      clickHandler: handleLeagueClick,
    },
    {
      key: "SeasonDetails.season",
      label: "Season",
      itemID: "GameID",
      clickHandler: handleGameClick,
    },
    {
      key: "HomeTeamDetails.city",
      itemID: "HomeTeamDetails.TeamID",
      label: "Home Team",
      clickHandler: handleTeamClick,
    },
    {
      key: "AwayTeamDetails.city",
      itemID: "AwayTeamDetails.TeamID",
      label: "Away Team",
      clickHandler: handleTeamClick,
    },
    {
      key: "Fights",
      label: "# of Fights",
      format: (fights) => (fights ? fights.length : 0),
      itemID: "GameID",
      clickHandler: handleGameClick,
    },
  ];

  const searchCategories = [
    { value: "id", label: "ID" },
    { value: "season", label: "Season" },
    { value: "date", label: "Date" },
    { value: "gameType", label: "Game Type" },
    { value: "league", label: "League" },
    { value: "homeTeam", label: "Home Team" },
    { value: "awayTeam", label: "Away Team" },
  ];

  const [gameData, setGameData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const fetchGames = useCallback(async () => {
    try {
      setIsLoading(true);
      let response = await getAllGames(location.search);
      setGameData(response.data.games);
      setPagination(response.data.pagination);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [location.search]);

  useEffect(() => {
    fetchGames();
  }, [fetchGames]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[60vh] bg-flyers-black">
        <Loader />
      </div>
    );
  }

  return (
    <div className="bg-flyers-black min-h-screen p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto space-y-6">
        <h1 className="font-heading text-3xl font-black uppercase tracking-wide text-flyers-orange">
          Games
        </h1>
        <Search categories={searchCategories} />
        <BasicTable columns={columns} data={gameData} />
        <Pagination pagination={pagination} />
      </div>
    </div>
  );
};
